import { render, staticRenderFns } from "./ReinstatementView.vue?vue&type=template&id=1969885b"
import script from "./ReinstatementView.vue?vue&type=script&lang=js"
export * from "./ReinstatementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports